<template>
  <div class="outer" :class="{inactive: !active}" style="display: block;">
    <Card class="card" :class="{checked: checked}">
      <div style="position: relative;">
        <img class="flag" v-if="!!course.flag" :src="require(`@/assets/flags/${course.flag}`)" />
        <img class="flag" v-if="!!course.icon" :src="require(`@/assets/icons/${course.icon}`)" />
        <img class="flag-shield" v-if="course.code === 'prod_HznQe906iKl2SK'" :src="require('@/assets/icons/nn-shield.png')" />
      </div>
      <div :class="{pushUp: course.icon === 'package.svg'}" v-html="course.title"></div>
      <div class="pricing" v-html="course.pricingInfo[entity]"></div>
      <div class="right">
        <RadioGroup :value="course.term" @on-change="onTerm" size="large" vertical>
          <!-- <Radio label="month">
            <span>{{$t('currency', {num: $options.filters.toCurrency(course.pricing.individual.month * vat)})}} / {{$t('license.term.month')}}</span>
          </Radio> -->
          <Radio label="year" style="margin-top: 10px;">
            <span v-if="course.pricing[entity].currency === 'nok'">{{$t('currency', {num: $options.filters.toCurrency(course.pricing[entity].year * vat)})}} / {{$t('license.term.privyear')}}</span>
            <span v-else>{{$options.filters.toCurrency(course.pricing[entity].year * vat, course.pricing[entity].currency)}} / {{$t('license.term.privyear')}}</span>
          </Radio>
        </RadioGroup>
        <div class="add-to-cart">
          <Button :type="checked ? 'error' : 'success'" @click="onClick">
            <Icon type="ios-cart" />
            <template v-if="checked">{{$t('license.removeFromCart')}}</template>
            <template v-else>{{$t('license.addToCart')}}</template>
          </Button>
        </div>
      </div>
    </Card>
    <input type="checkbox" :checked="checked" ref="checkBox" style="display: none;" />
  </div>
</template>

<script>
export default {
  name: 'CourseCard',
  props: {
    course: Object,
    entity: String,
    period: String,
    active: Boolean,
    checked: Boolean,
    vat: Number
  },
  data() {
    return {}
  },
  methods: {
    onClick(e) {
      if (!this.active || e.target.closest('.add-to-cart') === null) return;
      this.$emit('change', !this.checked);
    },
    onTerm(term) {
      this.$emit('term-change', term);
    },
    onNum(num) {
      this.$emit('students-change', num);
    }
  }
}
</script>

<style lang="scss">
.card {
  .inactive & {
    opacity: 0.4;

    &:hover {
      box-shadow: none !important;
    }
  }

  div.pushUp {
    margin-top: 0 !important;
    padding-bottom: 10px;
  }

  span.title {
    font-weight: 600;
  }

  ul {
    margin-left: 15px;
    font-size: 14px;
  }
}
</style>
<style scoped lang="scss">
.card {
  position: relative;
  width: 87%;
  min-height: 100px;
  display: inline-block;
  margin: 5px 25px;
  cursor: pointer;
  text-align: left;

  img.flag {
    max-height:60px;
    width: 100px;
    float: left;
  }
  img.flag-shield {
    position: absolute;
    top: 3px;
    right: 13px;
    max-height: 30px;
    width: auto;
  }

  div {
    float: left;
    margin: 2px 25px;
    font-size: 16px;

    @include respond-to(tablet) {
      font-size: 14px !important;
    }

    &.pricing {
      font-size: 11px;
      max-width: 24%;
    }
  }

  .right {
    float: right;
    margin: 0;
    margin-top: 2px;
    font-size: 16px;

    label {
      font-size: 16px;
    }

    @include respond-to(tablet) {
      font-size: 14px !important;

      label {
        font-size: 14px;
      }
    }

    .ivu-form-item {
      margin: 5px 0 0 25px;
    }

    .ivu-input-number{
      margin: 0;
    }

    .ivu-radio-group {
      margin: 0 auto;
    }

    .add-to-cart {
      margin-left: 10px;
      margin-right: 0 !important;
      margin-top: 10px;
      font-size: 16px;

      i {
        margin-right: 5px;
      }

      a {
        color: #727989;
      }
    }
  }

  &.checked {
    border: 2px solid #2d8cf0;
  }
  &.checked:hover {
    border-color: #4599f2; 
  }
}
</style>